.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  min-block-size: var(--control-height);
  padding-inline: var(--space-4);
  padding-block: 0;
  border: var(--border-width) solid transparent;
  border-radius: var(--radius-md);
  font-size: var(--text-md);
  font-weight: var(--weight-semibold);
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  text-decoration: none;
  transition:
    background-color var(--duration-fast) var(--ease-out),
    border-color var(--duration-fast) var(--ease-out),
    color var(--duration-fast) var(--ease-out);
  -webkit-tap-highlight-color: transparent;
}

.button[data-disabled] {
  cursor: not-allowed;
  opacity: 0.55;
}

.button[data-pending] {
  cursor: progress;
}

.sm {
  min-block-size: var(--control-height-sm);
  padding-inline: var(--space-3);
  font-size: var(--text-sm);
}

.primary {
  background: var(--color-primary);
  color: var(--color-on-primary);
}
.primary[data-hovered] {
  background: var(--color-primary-hover);
}
.primary[data-pressed] {
  background: var(--color-primary-active);
}

.secondary {
  background: var(--color-surface);
  color: var(--color-text);
  border-color: var(--color-border-strong);
}
.secondary[data-hovered] {
  background: var(--color-surface-hover);
  border-color: var(--color-text-subtle);
}
.secondary[data-pressed] {
  background: var(--color-surface-sunken);
}

.ghost {
  background: transparent;
  color: var(--color-text);
}
.ghost[data-hovered] {
  background: var(--color-surface-hover);
}
.ghost[data-pressed] {
  background: var(--color-surface-sunken);
}

.danger {
  background: var(--color-danger);
  color: #ffffff;
}
.danger[data-hovered] {
  background: var(--color-danger-hover);
}

.iconButton {
  min-inline-size: var(--control-height);
  padding-inline: 0;
}
.iconButton.sm {
  min-inline-size: var(--control-height-sm);
}

.spinner {
  animation: spin 0.9s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Links styled as buttons keep link semantics (navigation) and the button look. */
.link:hover.primary {
  background: var(--color-primary-hover);
}
.link:hover.secondary {
  background: var(--color-surface-hover);
}
